import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Minimal rectangular button. variant: primary | gold | outline | ghost. dark = on dark bg.
export function Btn({ to, href, onClick, children, variant = "primary", dark = false,
  className = "", type, arrow = true, testid, disabled }) {
  const base =
    "group inline-flex items-center justify-center gap-3 px-8 py-4 text-[11px] font-medium uppercase tracking-label transition-[background-color,border-color,color,opacity] duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] select-none";
  const variants = {
    primary: "bg-ink text-paper hover:bg-ink-700",
    gold: "bg-champagne text-ink hover:bg-champagne-soft",
    outline: dark
      ? "border border-white/25 text-white hover:border-white/70 hover:bg-white/[0.05]"
      : "border border-ink/25 text-ink hover:border-ink/70 hover:bg-ink/[0.04]",
    ghost: dark ? "text-white hover:opacity-60" : "text-ink hover:opacity-60",
  };
  const cls = `${base} ${variants[variant]} ${disabled ? "pointer-events-none opacity-40" : ""} ${className}`;
  const inner = (
    <>
      <span>{children}</span>
      {arrow && <ArrowRight size={15} strokeWidth={1.5}
        className="transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:translate-x-1.5" />}
    </>
  );
  if (to) return <Link to={to} data-testid={testid} className={cls}>{inner}</Link>;
  if (href) return <a href={href} data-testid={testid} className={cls}>{inner}</a>;
  return <button type={type || "button"} onClick={onClick} data-testid={testid} disabled={disabled} className={cls}>{inner}</button>;
}
export default Btn;
